import { render, staticRenderFns } from "./UpdateMyNumber.vue?vue&type=template&id=b5ff1550&scoped=true"
import script from "./UpdateMyNumber.vue?vue&type=script&lang=js"
export * from "./UpdateMyNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ff1550",
  null
  
)

export default component.exports